import { useParams } from "react-router-dom";
import { HeaderComponent } from "Components/Shared";
import ReviewRequestsList from "Components/Shared/ReviewRequests/List";

const PlayerScopedReviewRequests = () => {
  const { id } = useParams();
  const playerId = Number(id);
  return (
    <div className="ss-page-content d-flex flex-column flex-1 scroll-y bg-white">
      <HeaderComponent title="Review Requests" shouldShowNav={true} />
      <div className="ss-page-body d-flex flex-column flex-1 scroll-y py-4 px-4">
        {playerId > 0 ? (
          <ReviewRequestsList
            filters={{ requestor_id: playerId, requestor_type: "Player" }}
          />
        ) : (
          <div className="text-muted">Invalid player</div>
        )}
      </div>
    </div>
  );
};

export default PlayerScopedReviewRequests;
